import { useWebChatBotAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/WebChatBotAccountProvider/useWebChatBotAccount";
import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { useManageAccountsDrawer } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/providers/ManageAccountsDrawerContext";
import { ChannelTile } from "../ChannelTile";
import { ReactComponent as WebChatIcon } from "./assets/web-chat.svg";

export const WebChatTile: React.FC<{
  isSelected: boolean;
  onSelect: () => void;
}> = (props) => {
  const { t } = useTranslations();
  const {
    isConnected,
    connectWebChatBotAccount,
    isConnectingWebChatBotAccount,
  } = useWebChatBotAccount();
  const { openManageAccountDrawer } = useManageAccountsDrawer();

  return (
    <ChannelTile
      title={t({
        id: "cx-ai-agents-page.web-chat",
        defaultMessage: "Web chat",
      })}
      description={t({
        id: "cx-ai-agents-page.install-web-chat-description",
        defaultMessage: "Install Web chat to your Website",
      })}
      onClick={() =>
        isConnected
          ? openManageAccountDrawer({ name: "webChatBotAccount" })
          : connectWebChatBotAccount()
      }
      isConnected={isConnected}
      isDisabled={isConnectingWebChatBotAccount}
      icon={<WebChatIcon />}
      status={
        isConnected
          ? {
              type: "connected",
              text: t({
                id: "cx-ai-agents-page.ready-to-install",
                defaultMessage: "Ready to install",
              }),
            }
          : undefined
      }
      {...props}
    />
  );
};
